import { Injectable, inject } from '@angular/core';
import { LangActions, LoadLangSuccessAction } from '@library/store/lang/lang.actions';
import { LangFacade } from '@library/store/lang/lang.facade';
import { Actions, ofType } from '@ngrx/effects';
import { DefaultLanguage, getCrowdinCode } from '@store/langs/supportedLangs';
import { CookieService } from 'ngx-cookie-service';
import { take, tap } from 'rxjs/operators';
import { WebappLangFacade } from './webapp-langs.facade';

@Injectable()
export class LangsResolver {
  private readonly action$ = inject(Actions);
  private readonly langFacade = inject(LangFacade);
  private readonly webappLangFacade = inject(WebappLangFacade);
  private readonly cookieService = inject(CookieService);

  resolve(): boolean {
    this.loadLangsFromCache();
    this.fetchLangs();
    this.cacheLangs();
    return true;
  }

  loadLangsFromCache(): void {
    const cachedLangs = localStorage.getItem('langs');

    if (cachedLangs !== null) {
      try {
        const langs = JSON.parse(cachedLangs);
        if (typeof langs === 'object' && langs !== null) {
          this.langFacade.setLangs(langs);
        } else {
          console.error('err', langs);
          throw new Error('Langs from localstorage is not an object');
        }
      } catch (error) {
        console.error('Cannot parse langs from localstorage');
        console.error(error);
      }
    }
  }

  fetchLangs(): void {
    const code = this.cookieService.get('netatmocomlocale');
    const crowdinCode = getCrowdinCode(code) || DefaultLanguage;

    this.webappLangFacade.loadLangs(crowdinCode);
  }

  cacheLangs(): void {
    this.action$
      .pipe(
        ofType<LoadLangSuccessAction>(LangActions.loadLangsSuccess),
        tap((action) => {
          localStorage.setItem('langs', JSON.stringify(action.langs));
        }),
        take(1),
      )
      .subscribe();
  }
}
